import { InsightsDashboard } from '@myrtls/api-interfaces';
import { Action, createReducer, on } from '@ngrx/store';
import {
    getInsightsDashboardsFailureAction,
    getInsightsDashboardsRequestAction,
    getInsightsDashboardsSuccessAction,
    getInsightsGuestTokenSuccessAction,
    resetInsightsState,
} from './insights.actions';

export interface InsightsState {
    loading: boolean;
    dashboards: InsightsDashboard[];
    token: string | null;
    url: string | null;
}

const initialState: InsightsState = {
    loading: false,
    dashboards: [],
    token: null,
    url: null,
};

const reducer = createReducer(
    initialState,
    on(resetInsightsState, () => ({
        loading: false,
        dashboards: [],
        token: null,
        url: null,
    })),
    on(getInsightsDashboardsRequestAction, state => ({
        ...state,
        loading: true,
    })),
    on(
        getInsightsDashboardsSuccessAction,
        (state, { dashboards, url }) => ({
            ...state,
            dashboards,
            url,
            loading: false,
        }),
    ),
    on(getInsightsDashboardsFailureAction, state => ({
        ...state,
        loading: false,
    })),
    on(getInsightsGuestTokenSuccessAction, (state, { token }) => ({
        ...state,
        token,
    })),
);

export function insightsReducer(
    state: InsightsState | undefined,
    action: Action,
): InsightsState {
    return reducer(state, action);
}
